var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_1_1",
    transform: "translate(-889.000000, -420.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(485.000000, 394.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(404.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    transform: "translate(13.000000, 13.000000) rotate(180.000000) translate(-13.000000, -13.000000) ",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5260253,12.9990763 L19.1798612,8.35540344 C19.6042501,7.93095424 19.6042501,7.24278611 19.1798612,6.8183369 C18.7554723,6.3938877 18.0674019,6.3938877 17.6430131,6.8183369 L13,11.4728342 L8.35698695,6.8183369 C7.93259805,6.39388771 7.24452771,6.39388771 6.82013882,6.81833692 C6.39574993,7.24278612 6.39574992,7.93095424 6.82013881,8.35540344 L11.4739747,12.9990763 L6.82013881,17.6427492 C6.61524811,17.8459955 6.5,18.122663 6.5,18.4112824 C6.5,18.6999019 6.61524811,18.9765694 6.82013881,19.1798157 C7.02335624,19.3847355 7.29998443,19.5 7.58856288,19.5 C7.87714133,19.5 8.15376952,19.3847355 8.35698695,19.1798157 L13,14.5253184 L17.6430131,19.1798157 C17.8462305,19.3847355 18.1228587,19.5 18.4114371,19.5 C18.7000156,19.5 18.9766438,19.3847355 19.1798612,19.1798157 C19.3847519,18.9765694 19.5,18.6999019 19.5,18.4112824 C19.5,18.122663 19.3847519,17.8459955 19.1798612,17.6427492 L14.5260253,12.9990763 Z",
    id: "Path",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSWhite);
export default __webpack_public_path__ + "static/media/close_S_white.b53220e6ffcd3b7e6ba325f308398810.svg";
export { ForwardRef as ReactComponent };